import axios, { AxiosError } from "axios";
import { BASE_URL_API } from "constants/base-url-api";
import { CreateAccountParams } from "types/userCreate";

export interface CreateTemporaryDataParams {
  email?: string;
}
interface LoginRequest {
  email: string;
  password: string;
  new_password?: string;
  session?: string;
}

export const API = axios.create({
  baseURL: BASE_URL_API,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});

const login = async (params: LoginRequest) => {
  try {
    const response = await API.post("/login", { ...params });
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError;
      if (axiosError.response?.status === 401) {
        return { message: "Usuário ou senha inválidos" };
      }
    }
    throw error;
  }
};

const getDestinations = async (local: string) => {
  const response = await API.get("/hotels/destinations", {
    params: {
      keyword: local,
    },
  });
  return response.data;
};

const createAccount = async (params: CreateAccountParams) => {
  const response = await API.post("/users", { ...params });
  return response.data;
};

export const ApisService = {
  login,
  createAccount,
  getDestinations,
};
